var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40735 5.3803H11.4819L7.62419 1.70698C7.42219 1.51463 7.41436 1.19506 7.60676 0.993115C7.79892 0.791425 8.11858 0.783348 8.32083 0.975697L12.7265 5.17103C12.9171 5.36186 13.0224 5.6153 13.0224 5.88515C13.0224 6.15474 12.9171 6.40843 12.7176 6.60759L8.32058 10.7944C8.22287 10.8874 8.09763 10.9337 7.97239 10.9337C7.83907 10.9337 7.70574 10.8812 7.60651 10.777C7.41411 10.575 7.42194 10.2557 7.62394 10.0633L11.4978 6.39H1.40735C1.12859 6.39 0.902344 6.16383 0.902344 5.88515C0.902344 5.60647 1.12859 5.3803 1.40735 5.3803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.25be4fc7241c62b3f1e603a308fbe09c.svg";
export { ForwardRef as ReactComponent };